var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown',{attrs:{"position":"is-bottom-right","mobile-modal":false},scopedSlots:_vm._u([{key:"trigger",fn:function({ active }){return [_c('img',{staticClass:"logo",attrs:{"src":"/images/forefront-icon.png","alt":"Forefront"}})]}}])},[_vm._v(" "),_c('a',{staticClass:"navbar-item",on:{"click":_vm.logout}},[_vm._v("Logout")])])
}
var staticRenderFns = []

export { render, staticRenderFns }